import React, { Component } from "react";
import { HashRouter, Routes, Route, Link } from "react-router-dom";
import "./App.css";
import MainMenu from "./components/MainMenu/MainMenu";
import Category from "./components/Category/Category";
import Footer from "./components/Footer/Footer";

class App extends Component {
  state = {
    superCategories: [
      { id: 0, name: ["ΚΑΦΕΔΕΣ & ΡΟΦΗΜΑΤΑ", "COFFEE & BEVEREGES"] },
      { id: 1, name: ["ΑΛΚΟΟΛΟΥΧΑ", "ALCOHOLIC DRINKS"] },
      {
        id: 2,
        name: ["FOOD by CAMINO BIANCO", "FOOD"],
        info: "Διαθέσιμα για Delivery & Take Away",
        navigation: [8, 15],
        image: "assets/logos/camino.png",
      },
      {
        id: 3,
        name: ["SUSHI"],
        info: "Διαθέσιμα για Delivery & Take Away",
        navigation: [16, 19],
        image: "assets/logos/sushi-logo.png",
      },
      // { id : 3, name : ['DELIVERY & TAKE AWAY'], info : 'Powered by Bottega', image : 'assets/logos/bottega-nobg.png'}
    ],
    categories: [
      {
        id: 0,
        name: ["ΚΑΦΕΣ", "COFFEE"],
        superID: 0,
        catID: 0,
        superCat: false,
        img: "assets/images/categories/coffee.jpg",
      },
      {
        id: 1,
        name: ["ΡΟΦΗΜΑΤΑ", "BEVEREGES"],
        superID: 0,
        catID: 1,
        superCat: false,
        img: "assets/images/categories/tea.jpg",
      },
      {
        id: 2,
        name: ["ΧΥΜΟΙ & ΑΝΑΨΥΚΤΙΚΑ", "JUICES & SOFT DRINKS"],
        superID: 0,
        catID: 2,
        superCat: false,
        img: "assets/images/categories/juice.jpg",
      },
      {
        id: 3,
        name: ["COCKTAILS", "COCKTAILS"],
        superID: 1,
        catID: 7,
        superCat: false,
        img: "assets/images/categories/cocktails_25.jpg",
        cat_filters: [
          "HandCrafted Cocktails",
          "Aperitivo",
          "Classic Cocktails",
          "Best Of 2013-2023",
        ],
      },
      {
        id: 4,
        name: ["ΜΠΥΡΕΣ", "BEER"],
        superID: 1,
        catID: 3,
        superCat: false,
        img: "assets/images/categories/beer.jpg",
      },
      {
        id: 5,
        name: ["ΚΡΑΣΙΑ", "WINE"],
        superID: 1,
        catID: 4,
        superCat: false,
        img: "assets/images/categories/wine.jpg",
        cat_filters: ["ΛΕΥΚΑ", "ΕΡΥΘΡA", "ΡΟΖΕ", "ΕΠΙΔΟΡΠΙΑ"],
      },
      {
        id: 6,
        name: ["ΣΑΜΠΑΝΙΕΣ", "CHAMPAGNE"],
        superID: 1,
        catID: 5,
        superCat: false,
        img: "assets/images/categories/chapagne.jpg",
      },
      {
        id: 7,
        name: ["PREMIUM ΠΟΤΑ", "PREMIUM DRINKS"],
        superID: 1,
        catID: 6,
        superCat: false,
        img: "assets/images/categories/drinks.jpg",
        cat_filters: ["RUMS", "VODKA", "TEQUILA", "GIN", "WHISKEY"],
      },
      // { id : 8, name : ['GOOD MORNING'], superID : 2, catID : 8, superCat : true , img : 'assets/images/categories/cb_morning.jpg'},
      // { id : 9, name : ['PIZZA ROLLS'], superID : 2, catID : 8, superCat : true ,  img : 'assets/images/categories/cb_rolls.jpg'},
      // { id : 10, name : ['COME AND TAKE MY PIECE'], superID : 2, catID : 8, superCat : true ,  img : 'assets/images/categories/cb_piece.jpg'},
      {
        id: 8,
        name: ["BRUNCH"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/brunch.jpeg",
        info: "Σερβίρεται μέχρι τις 15:00",
      },
      {
        id: 9,
        name: ["BITE AVENUE"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/biteavenue.jpeg",
      },
      // { id : 11, name : ['PORTAFOGLIO'], superID : 2, catID : 8, superCat : true ,  img : 'assets/images/categories/cb_portafoglio.jpg'},
      {
        id: 10,
        name: ["STARTERS"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/starters.jpeg",
      },
      // { id : 12, name : ['SALADS'], superID : 2, superCat : true, catID : 8,  img : 'assets/images/categories/cb_salads.jpg'},
      {
        id: 11,
        name: ["SALAD BAR"],
        superID: 2,
        superCat: true,
        catID: 8,
        img: "assets/images/categories/salad.jpeg",
      },
      // { id : 13, name : ['PIZZA SICILIANA'], superID : 2, catID : 8, superCat : true,  img : 'assets/images/categories/cb_sicily.jpg'},
      // { id : 14, name : ["2ND FLOOR"], superID : 2, catID : 8, superCat : true,  img : 'assets/images/categories/cb_floor.jpg'},
      // {
      //   id: 12,
      //   name: ["SUSHI"],
      //   superID: 2,
      //   catID: 8,
      //   superCat: true,
      //   img: "assets/images/categories/rice.jpeg",
      // },
      {
        id: 12,
        name: ["RICE"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/rice.jpeg",
      },
      // { id : 15, name : ['PIZZA CONTEMPORANEA'], superID : 2, catID : 8, superCat : true,  img : 'assets/images/categories/cb_contemporanea.jpg'},
      {
        id: 13,
        name: ["PIZZA"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/pizza.jpeg",
      },
      // { id : 16, name : ["IT'S ALWAYS PASTA"], superID : 2, catID : 8, superCat : true,  img : 'assets/images/categories/cb_pasta.jpg'},
      {
        id: 14,
        name: ["PASTA"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/pasta.jpeg",
      },
      {
        id: 15,
        name: ["DESSERTS"],
        superID: 2,
        catID: 8,
        superCat: true,
        img: "assets/images/categories/cb_dessert.jpg",
      },
      {
        id: 16,
        name: ["APPETIZERS"],
        superID: 3,
        catID: 16,
        superCat: true,
        img: "assets/images/categories/ss-01.jpeg",
      },
      {
        id: 17,
        name: ["RICE BOWLS"],
        superID: 3,
        catID: 16,
        superCat: true,
        img: "assets/images/categories/ss-02.jpeg",
      },
      {
        id: 18,
        name: ["WOK NOODLES"],
        superID: 3,
        catID: 16,
        superCat: true,
        img: "assets/images/categories/ss-03.jpeg",
      },
      {
        id: 19,
        name: ["SUSHI ROLLS"],
        superID: 3,
        catID: 16,
        superCat: true,
        img: "assets/images/categories/ss-04.jpeg",
      },
      // { id : 17, name : ['ΚΑΦΕΣ' , 'COFFEE'], superID : 3, catID : 16, superCat : false, takeAway : false, img : 'assets/images/categories/coffee.jpg'},
      // { id : 18, name : ['ΡΟΦΗΜΑΤΑ & ΧΥΜΟΙ' , 'JUICES & BEVEREGES'], superID : 3,  catID : 17, superCat : false, takeAway : false, img : 'assets/images/categories/tea.jpg'},
      // { id : 19, name : ['COCKTAILS' , 'COCKTAILS'], superID : 3, catID : 18, superCat : false, takeAway : false, img : 'assets/images/categories/cocktails.jpg' , info : 'powered by', logo : 'assets/logos/bottega-nobg.png'}
    ],
    products: [
      {
        cat_id: 0,
        items: [
          { id: 1, name: ["Espresso"], price: 3 },
          { id: 2, name: ["Espresso Macchiato"], price: 3.3 },
          { id: 3, name: ["Espresso Διπλό"], price: 3.5 },
          { id: 4, name: ["Cappuccino"], price: 3.8 },
          { id: 5, name: ["Cappuccino Διπλό"], price: 4 },
          { id: 6, name: ["Cappuccino Latte"], price: 4 },
          { id: 7, name: ["Americano"], price: 3.5 },
          { id: 8, name: ["Freddo Espresso"], price: 3.5 },
          { id: 9, name: ["Freddo Cappuccino"], price: 4 },
          { id: 10, name: ["Φίλτρου"], price: 3.5 },
          { id: 11, name: ["Φραπέ"], price: 3.5 },
          { id: 12, name: ["Ισπανικός Κρύος"], price: 4 },
          { id: 13, name: ["Ισπανικός Ζεστός"], price: 4 },
          { id: 14, name: ["Γερμανικός"], price: 3.5 },
          { id: 15, name: ["Νες"], price: 3.5 },
          { id: 16, name: ["Ελληνικός Μονός"], price: 3 },
          { id: 17, name: ["Ελληνικός Διπλός"], price: 3.5 },
        ],
      },
      {
        cat_id: 1,
        sub_category: ["ΣΟΚΟΛΑΤΑ"],
        items: [
          { id: 1, name: ["Κακάο"], price: 3.5 },
          { id: 2, name: ["Σοκολάτα Κρύα"], price: 4 },
          { id: 3, name: ["Σοκολάτα Ζεστή"], price: 4 },
          { id: 4, name: ["Σοκολάτα Λευκή Κρύα"], price: 4 },
          { id: 5, name: ["Σοκολάτα Λευκή Ζεστή"], price: 4 },
        ],
      },
      {
        cat_id: 1,
        sub_category: ["ΤΣΑΪ"],
        items: [
          { id: 7, name: ["Fuze Πράσινο τσάι"], price: 3.5 },
          { id: 8, name: ["Fuze Ροδάκινο / Λεμόνι"], price: 3.5 },
          { id: 9, name: ["Fuze Zero Ροδάκινο / Λεμόνι"], price: 3.5 },
        ],
      },
      {
        cat_id: 1,
        sub_category: ["BARU"],
        items: [
          {
            id: 1,
            name: ["Matcha Latte"],
            price: 4.5,
            description: ["with green tea"],
          },
          {
            id: 2,
            name: ["Matcha Latte Ice"],
            price: 4.5,
            description: ["with green tea"],
          },
          {
            id: 3,
            name: ["Vanilla Chai Latte"],
            price: 4.5,
            description: ["with black tea and exotic spices"],
          },
          {
            id: 4,
            name: ["Vanilla Chai Latte Ice"],
            price: 4.5,
            description: ["with black tea and exotic spices"],
          },
          {
            id: 5,
            name: ["Pink Chai Latte"],
            price: 4.5,
            description: ["with black tea, beetroot and exotic spices"],
          },
          {
            id: 6,
            name: ["Pink Chai Latte Ice"],
            price: 4.5,
            description: ["with black tea, beetroot and exotic spices"],
          },
          {
            id: 7,
            name: ["Pumpkin Spice Latte"],
            price: 4.5,
            description: ["with coffee and exotic spices"],
          },
          {
            id: 8,
            name: ["Pumpkin Spice Latte Ice"],
            price: 4.5,
            description: ["with coffee and exotic spices"],
          },
          {
            id: 9,
            name: ["Golden Chai Latte"],
            price: 4.5,
            description: ["with tumeric, black tea and exotic spices"],
          },
          {
            id: 10,
            name: ["Golden Chai Latte Ice"],
            price: 4.5,
            description: ["with tumeric, black tea and exotic spices"],
          },
          {
            id: 11,
            name: ["Spiced Chai Latte"],
            price: 4.5,
            description: ["with  black tea and masala spices"],
          },
          {
            id: 12,
            name: ["Spiced Chai Latte Ice"],
            price: 4.5,
            description: ["with  black tea and masala spices"],
          },
        ],
      },
      {
        cat_id: 2,
        sub_category: ["BEVERAGES"],
        items: [
          {
            id: 17,
            name: ["Coca-Cola"],
            price: 3.5,
            description: "Regular, Zero Sugar, Zero Caffeine, Zero Light",
          },
          { id: 19, name: ["Fanta Orange"], price: 3.5 },
          { id: 20, name: ["Fanta Lemon"], price: 3.5 },
          { id: 21, name: ["Sprite"], price: 3.5 },
          {
            id: 25,
            name: ["Schweppes"],
            price: 3.5,
            description: "Soda Water, Indian Tonic",
          },
          { id: 27, name: ["Red Bull"], price: 6 },
        ],
      },
      {
        cat_id: 2,
        sub_category: ["PREMIUM BEVERAGES"],
        items: [
          { id: 1, name: ["Schweppes Pink Grapefruit 250ml"], price: 4 },
          {
            id: 2,
            name: ["Schweppes Orangeade with Orange Blosson (no sugar)"],
            price: 4,
          },
          {
            id: 3,
            name: ["Schweppes Lemonade with Hibiscus & Pergamon (no sugar)"],
            price: 4,
          },
          { id: 4, name: ["Schweppes Pink Signature 200ml"], price: 4 },
          { id: 5, name: ["Three Cents Ginger Beer 200ml"], price: 5 },
          { id: 6, name: ["Three Cents Pink Grapefruit Soda 200ml"], price: 5 },
          { id: 7, name: ["Three Cents Cherry Soda 200ml"], price: 5 },
          { id: 8, name: ["Three Cents Aegean Tonic 200ml"], price: 5 },
          {
            id: 9,
            name: ["Three Cents Mandarin & Bergamot Soda 200ml"],
            price: 5,
          },
        ],
      },
      {
        cat_id: 2,
        sub_category: ["XYMOI"],
        items: [
          {
            id: 1,
            name: ["Χυμοί Amita"],
            price: 3.5,
            description: "Λεμόνι, Cranberry, Ανανάς, Φράουλα, Ανάμεικτος",
          },
          { id: 3, name: ["Φρέσκος Χυμός Πορτοκάλι"], price: 4 },
          // { id : 2, name : ['Φρέσκος Χυμός Ανάμεικτος'], price : 4},
          // { id : 5, name : ['Σπιτική Λεμονάδα'], price : 4.5}
        ],
      },
      {
        cat_id: 2,
        sub_category: ["WATER"],
        items: [
          { id: 7, name: ["Perrier"], price: 3.5 },
          { id: 8, name: ["Pelegrino"], price: 4 },
        ],
      },
      {
        cat_id: 4,
        items: [
          { id: 1, name: ["Corona, 330ml "], price: 5 },
          { id: 2, name: ["Bud , 330ml "], price: 6 },
          { id: 3, name: ["Stella Artois , 330ml "], price: 5 },
          { id: 4, name: ["Franziskaner Weissbier, 500ml "], price: 6 },
          { id: 5, name: ["Beck’s, 275ml "], price: 4 },
          { id: 6, name: ["Leffe Blonde 330ml "], price: 6 },
          { id: 7, name: ["Corona cero 0.0%"], price: 5 },
          { id: 8, name: ["Stella Artois 0.0%"], price: 5 },
          { id: 9, name: ["Stella Artois Draft 400ml"], price: 5 },
          { id: 10, name: ["Beck’s Draft, 330ml "], price: 4 },
          { id: 11, name: ["Beck’s Draft, 500ml "], price: 6 },
          /*
          { id : 1, name : ['Mythos'], price : 4},
          { id : 2, name : ['Mythos Radler'], price : 4},
          { id : 3, name : ['Mythos Ice'], price : 5},
          { id : 4, name : ['Fix Άνευ'], price : 4},
          { id : 5, name : ['Fix Dark'], price : 4},
          { id : 6, name : ['Kaiser'], price : 4},
          { id : 7, name : ['Νήσος Pilsner'], price : 5},
          { id : 8, name : ['Νήσος Lager'], price : 5},
          { id : 9, name : ['Νήσος Gluten Free'], price : 5},
          { id : 10, name : ['Νήσος Αποκάλυψη'], price : 5},
          { id : 11, name : ['Νήσος 7 Μποφόρ'], price : 5},
          { id : 12, name : ['Νήσος Θολή'], price : 5},
          { id : 13, name : ['Carlsberg Draft'], price : 4, extraPrice : { name : "Μεγάλο", price : 5}},
           */
        ],
      },
      {
        cat_id: 5,
        sub_category: ["ΛΕΥΚΑ"],
        items: [
          { id: 1, name: ["Κτήμα Άλφα"], price: 5, filter: "ΛΕΥΚΟ" },
          {
            id: 2,
            name: ["Κτήμα Άλφα Μαλαγουζιά"],
            price: 6.5,
            extraPrice: { name: "φιάλη", price: 35 },
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 3,
            name: ["Bostani Κτήμα Άλφα (Ασύρτικο, Μαλαγουζιά)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 35 },
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 4,
            name: ["Κτήμα Γεροβασιλείου Μαλαγουζιά"],
            price: 45,
            description: "Μόνο φιάλη",
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 5,
            name: ["Κτήμα Γεροβασιλείου (Ασύρτικο, Μαλαγουζιά)"],
            price: 45,
            description: "Μόνο φιάλη",
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 6,
            name: ["Κτήμα Άλφα Sauvignon Blanc"],
            price: 50,
            description: "Μόνο φιάλη",
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 7,
            name: ["Κτήμα Άλφα Chardonnay"],
            price: 60,
            description: "Μόνο φιάλη",
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 8,
            name: ["Κτήμα Βιβλία Χώρα (Ασύρτικο, Sauvignon Blanc)"],
            price: 40,
            description: "Μόνο φιάλη",
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 9,
            name: ["Thema Κτήμα Παυλίδη (Ασύρτικο, Sauvignon)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 40 },
            filter: "ΛΕΥΚΟ",
          },
          {
            id: 10,
            name: ["Ανάσασμα Κτήμα Καρακώστα (Sauvignon)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 40 },
            filter: "ΛΕΥΚΟ",
          },
        ],
      },
      {
        cat_id: 5,
        sub_category: ["ΕΡΥΘΡA"],
        items: [
          {
            id: 1,
            name: ["Κτήμα Άλφα Αξία (Syrah, Ξινόμαυρο)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 35 },
            filter: "ΕΡΥΘΡΟ",
          },
          {
            id: 2,
            name: ["Bostani Κτήμα Άλφα (Merlot, Ξινόμαυρο)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 35 },
            filter: "ΕΡΥΘΡΟ",
          },
          {
            id: 3,
            name: ["Κτήμα Άλφα Tannat"],
            price: 60,
            description: "Μόνο φιάλη",
            filter: "ΕΡΥΘΡΟ",
          },
          {
            id: 4,
            name: ["Κτήμα Γεροβασιλείου (Λημνιό, Syrah, Merlot)"],
            price: 60,
            description: "Μόνο φιάλη",
            filter: "ΕΡΥΘΡΟ",
          },
          {
            id: 5,
            name: [
              "Κτήμα Βιβλία Χώρα (Αγιωργίτικο, Cabarnet Sauvignon, Merlot)",
            ],
            price: 60,
            description: "Μόνο φιάλη",
            filter: "ΕΡΥΘΡΟ",
          },
        ],
      },
      {
        cat_id: 5,
        sub_category: ["ΡΟΖΕ"],
        items: [
          {
            id: 1,
            name: ["Pinot Grigio"],
            price: 5,
            extraPrice: { name: "φιάλη", price: 30 },
            filter: "ΡΟΖΕ",
          },
          {
            id: 2,
            name: ["Κτήμα Άλφα (Syrah, Ξινόμαυρο)"],
            price: 7.5,
            extraPrice: { name: "φιάλη", price: 40 },
            filter: "ΡΟΖΕ",
          },
          {
            id: 3,
            name: ["Κτήμα Βιβλία Χώρα (Syrah)"],
            price: 60,
            description: "Μόνο φιάλη",
            filter: "ΡΟΖΕ",
          },
          {
            id: 4,
            name: ["Thema Κτήμα Παυλίδη (Syrah)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 40 },
            filter: "ΡΟΖΕ",
          },
          {
            id: 5,
            name: ["Ανάσασμα Κτήμα Καρακώστα (Ξινόμαυρο)"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 40 },
            filter: "ΡΟΖΕ",
          },
        ],
      },
      {
        cat_id: 5,
        sub_category: ["ΕΠΙΔΟΡΠΙΑ"],
        items: [
          {
            id: 1,
            name: ["Batasiolo Ροζέ (Αφρώδες οίνος)"],
            price: 5,
            extraPrice: { name: "φιάλη", price: 30 },
            filter: "ΕΠΙΔΟΡΠΙΑ",
          },
          {
            id: 2,
            name: ["Libra Λευκό, Ροζέ"],
            price: 6,
            extraPrice: { name: "φιάλη", price: 30 },
            filter: "ΕΠΙΔΟΡΠΙΑ",
          },
          {
            id: 3,
            name: ["Πρόρωγος Ερυθρό"],
            price: 5,
            extraPrice: { name: "φιάλη", price: 30 },
            filter: "ΕΠΙΔΟΡΠΙΑ",
          },
          {
            id: 4,
            name: ["Γιώργος Λαφαζάνης Artisti"],
            price: 6,
            filter: "ΕΠΙΔΟΡΠΙΑ",
          },
          {
            id: 5,
            name: ["Κρασί λευκό free alcohol"],
            price: 5,
            filter: "ΕΠΙΔΟΡΠΙΑ",
          },
        ],
      },
      {
        cat_id: 6,
        items: [
          { id: 1, name: ["Moët Chandon Brut"], price: 140 },
          { id: 2, name: ["Moët Chandon Ice"], price: 160 },
          { id: 3, name: ["Moët Chandon Ice Rose"], price: 170 },
          { id: 4, name: ["Moët Chandon Rose"], price: 140 },
          { id: 5, name: ["Emmelis"], price: 60 },
        ],
      },
      {
        cat_id: 3,
        sub_category: ["HandCrafted Cocktails"],
        items: [
          {
            id: 1,
            name: ["Tropical Dry"],
            price: 9.5,
            description:
              "Gin infused basil, Apple sour liquer, Cordial banana-green tea, Citric acid, Schweppers tropical fusion",
          },
          {
            id: 2,
            name: ["Rum Tango"],
            price: 9.5,
            description:
              "White rum, Cordial passion yuzu vanilla, Cacao white liquor,  Citric acid",
          },
          {
            id: 3,
            name: ["Cubano Intense"],
            price: 9,
            description:
              "Dark rum, Cordial raspberry mango pistachio, Chocolate bitters, Raspberry shrub, Citric acid",
          },
          {
            id: 4,
            name: ["Salted Irish"],
            price: 10,
            description:
              "Whiskey-butter, Cordial salted caramel-hazelnut, Amaro montenegro, Citric acid, Orange bitters",
          },
          {
            id: 5,
            name: ["Pepper Splash"],
            price: 9.5,
            description:
              "Vodka aperol infused, Πιπεριά Φλωρίνης, Cordial hibiscus-orgeat, Lime",
          },
          {
            id: 6,
            name: ["Bloody Senora"],
            price: 9,
            description:
              "Tequila bianco, Honey Syrup, Citric Acid, Cordial orange mint strawberry beetroot, Martini bianco, infused turmeric",
          },
        ],
      },
      {
        cat_id: 3,
        sub_category: ["Aperitivo"],
        items: [
          {
            id: 1,
            name: ["Aperol Spritz"],
            price: 8.5,
            description: "Aperol, Cinzano To Spritz, Soda water",
          },
          {
            id: 2,
            name: ["Campari Spritz"],
            price: 8.5,
            description: "Campari, Cinzano To Spritz, Soda water",
          },
          {
            id: 3,
            name: ["Campari Soda"],
            price: 8,
            description: "Campari, Soda water",
          },
          {
            id: 4,
            name: ["Eros"],
            price: 8.5,
            description:
              "Aperol Αρωματισμένο με Φράουλα, Elderflower, Χυμός Λεμόνι, Ραβέντι, Orange Bitters, Rose Αφρώδες Οίνος",
          },
          // { id : 5, name : ['Pathos'], price : 8.5, description : "Montenegro Amaro, Περγαμόντο, Three cents Aegean Tonic"}
          {
            id: 5,
            name: ["Strawbar Spritz"],
            price: 8.5,
            description: "Strawbar, Vanilla, Lime, Λουίζα, Batasiolo, Soda",
          },
        ],
      },
      {
        cat_id: 3,
        sub_category: ["Classic Cocktails"],
        items: [
          {
            id: 1,
            name: ["Daiquiri"],
            price: 9,
            description: "Havana Club Añejo 3 Años, Σιρόπι Ζάχαρης, Lime",
          },
          {
            id: 2,
            name: ["Margarita"],
            price: 9,
            description: "Olmeca Tequila Silver, Λικέρ Πορτοκαλιού, Lime",
          },
          {
            id: 3,
            name: ["Dry Martini"],
            price: 9,
            description:
              "Absolut Vodka ή Beefeater London Dry Gin, Ξηρό Βερμούτ, Πράσινη ελιά",
          },
          {
            id: 4,
            name: ["Caipirinha"],
            price: 9,
            description: "Brazillian Rum, Καστανή Ζάχαρη, Lime",
          },
          {
            id: 5,
            name: ["Cosmopolitan"],
            price: 9,
            description: "Absolut Vodka, Φρέσκος Χυμός Cranberry, Lime",
          },
          {
            id: 6,
            name: ["Gin Basil Smash"],
            price: 9,
            description:
              "Beefeater London Dry Gin, Φύλλα Βασιλικού, Σιρόπι Ζάχαρης, Lime",
          },
          {
            id: 7,
            name: ["Mai Tai"],
            price: 9,
            description:
              "Havana Club Añejo 3 Años, Havana Club Añejo Especial, Λικέρ Πορτοκαλιού, Σιρόπι, Πικραμύγδαλο, Lime",
          },
          {
            id: 8,
            name: ["Mojito "],
            price: 9,
            description:
              "Havana Club Añejo 3 Años, Φύλλα Δυόσμου, Σιρόπι Ζάχαρης, Lime, Schweppes soda water",
          },
          {
            id: 9,
            name: ["Zombie"],
            price: 12,
            description:
              "Havana Club Añejo 3 Años, Havana Club Añejo Especial, Ρούμι Υψηλών Αλκοολικών Βαθμών, Falernum, Σιρόπι Κανελας, Γρεναδίνη, Αρωματικές Σταγόνες, Φρέσκος Χυμός Grapefruit, Lime)",
          },
          {
            id: 10,
            name: ["Manhattan"],
            price: 9,
            description:
              "Four Roses Bourbon, Γλυκόπικρες Αρρωματικές Σταγόνες, Βερμούτ",
          },
          {
            id: 11,
            name: ["Negroni"],
            price: 9,
            take: 5,
            description: "Campari, Beefeater London Dry Gin, Γλυκό Βερμούτ)",
          },
          {
            id: 12,
            name: ["Boulevard"],
            price: 9,
            description:
              "Four Roses Bourbon, Campari, Γλυκό Βερμούτ, Amaro Montenegro",
          },
          {
            id: 13,
            name: ["Paloma"],
            price: 9,
            description:
              "Olmeca Tequila Silver, three cents pink grapefruit soda, Agave Syrup, Salt, Lime",
          },
        ],
      },

      {
        cat_id: 3,
        sub_category: ["Best Of 2013-2023"],
        items: [
          {
            id: 1,
            name: ["Carmen"],
            price: 9,
            description:
              "Filandia Vodka, Λικέρ κακάο λευκό, Σιρόπι φράουλας, Ελαφριά κρέμα γάλακτος, Τριμμένη κουβερτούρα (γλυκό)",
          },
          {
            id: 2,
            name: ["Dream"],
            price: 9,
            description:
              "Filandia Vodka αρωματισμένη με αχλάδι, Λικέρ πορτοκαλιού, Γρεναδίνη, Λικέρ από κεράσια μαρασκίνο, Φρέσκο lime (γλυκόξινο)",
          },
          {
            id: 3,
            name: ["Berry Secret"],
            price: 9,
            description:
              "Absolut Vanilla, Σπιτικό σιρόπι τζίντζερ, Πουρές φρούτα του πάθους, Φρέσκο lime, Μπισκότο (γλυκόξινο φρουτώδες)",
          },
          {
            id: 4,
            name: ["Flavored Berry"],
            price: 9,
            description:
              "Filandia Vodka, Κόκκινα βατόμουρα, Σιρόπι πράσινου τσαγιού και φρέσκο lime (γλυκόξινο φρουτώδες)",
          },
          {
            id: 5,
            name: ["Mr. Melissores"],
            price: 9,
            description:
              "Filandia Vodka, Mηλο, Passion fruit, Lime και μέλι (γλυκόξινο)",
          },
          {
            id: 6,
            name: ["Big Apple"],
            price: 9,
            take: 5,
            description:
              "Filandia Vodka, Φρέσκο lime, Λικέρ μήλου, Λικέρ βατόμουρου (γλυκόξινο)",
          },
        ],
      },
      // { cat_id : 8,
      //   items : [
      //     { id : 1, name : ['Simplicity'], price : 6, description : 'Τι καλύτερο από την απλότητα μιας ζουμερής ομελέτας. Συνοδεύεται από φρέσκια σαλάτα'},
      //     { id : 2, name : ['Sando'], price : 8, description : 'Milk bread γεμισμένο με Scrambled eggs εμπλουτισμένα με ελαφρά μπαχαρικά. Συνοδεύεται από μαγιονέζα βασιλικού και φρέσκια σαλάτα'},
      //     { id : 3, name : ['Croque Madame'], price : 6.5, description : 'Τραγανές φέτες ψωμιού με sauce mornay και prosciutto cotto. Συνοδεύονται από αβγό τηγανητό'},
      //     { id : 4, name : ['Cozy'], price : 6.5, description : 'Πεϊνιρλί γεμιστό με φέτα, ντοματίνια, ελιές και μελιτζάνα'},
      //     { id : 5, name : ['Fabulous'], price : 8, description:'Αφράτα pancakes με πραλίνα φουντουκιού και κρέμα Tiramisu. Συνοδεύεται από affogato al cafe και βατόμουρο' },
      //     { id : 8, name : ['Pinky'], price : 8, description:'Pancake με λευκή πραλίνα cream Anglaise, τραγανά μαρεγκάκια, φρέσκες φράουλες και σάλτσα raspberry' },
      //   ]
      // },
      {
        cat_id: 8,
        sub_category: ["SAVORY SIDE"],
        items: [
          {
            id: 1,
            name: ["The Omelette"],
            price: 7,
            description:
              "Ομελέτα γεμιστή με μαλακά τυριά, prosciutto cotto, παρμεζάνα και φρέσκια σαλάτα",
          },
          {
            id: 2,
            name: ["Sando"],
            price: 8,
            description:
              "Milk bread γεμισμένο με scrambled eggs εμπλουτισμένα με ελαφρά μπαχαρικά. Συνοδεύεται από μαγιονέζα βασιλικού και φρέσκια σαλάτα",
          },
          {
            id: 3,
            name: ["Croque Madame"],
            price: 7.5,
            description:
              "Τραγανές φέτες από χειροποίητο ψωμί του toast με sauce monray και prosciutto cotto. Συνοδεύονται από αβγό τηγανητό",
          },
          {
            id: 4,
            name: ["So Delicious"],
            price: 7,
            description:
              "Χειροποίητο πεϊνιρλί γεμισμένο με στραπατσάδα ελιές και τριμμένη φέτα",
          },
        ],
      },
      {
        cat_id: 8,
        sub_category: ["TREAT YOURSELF"],
        items: [
          {
            id: 1,
            name: ["Japanese Pancakes"],
            price: 7.8,
            description:
              "Pancake με λευκή πραλίνα cream Anglaise τραγανά μαρεγκάκια φρέσκες φράουλες και σάλτσα raspberry",
          },
          {
            id: 2,
            name: ["Fabulous Chocolate Chip Pancakes"],
            price: 8,
            description:
              "Ζύμη pancakes εμπλουτισμένη με chocolate chips πραλίνα φουντουκιού, κροκάν φουντούκι butterscotch caramel και παγωτό σοκολάτα",
          },
          {
            id: 3,
            name: ["Croisants"],
            price: 6,
            description:
              "Smashed με πραλίνα φιστικιού ή κρέμα tiramisu ή πραλίνα σοκολάτα",
          },
        ],
      },
      {
        cat_id: 9,
        // cat_description : ["Κομμάτια αφράτης ζύμης alla Siciliana"],
        items: [
          {
            id: 1,
            name: ["Hall of Fame Toast"],
            price: 5.8,
            description:
              "Κλασικό toast σε τρία επίπεδα με gouda και γαλοπούλα, μαγιονέζα και πατάτες τηγανητές",
          },
          {
            id: 2,
            name: ["Pizza Roll Carbonara"],
            price: 5,
            description:
              "Sauce από κρέμα γάλακτος με bacon λιωμένη mozzarella και τριμμένη parmesan",
          },
          {
            id: 3,
            name: ["Magic Mushroom"],
            price: 6,
            description:
              "Αφράτη ζύμη ψημένη με mozzarella και μανιτάρια με sauce μανιταριών και λάδι λευκής τρούφας",
          },
          {
            id: 4,
            name: ["Mini Cheeseburger in Paradise"],
            price: 8,
            description:
              "Αφράτο potato bun γεμισμένο με το μπιφτέκι cheddar, ζουμερή ντομάτα, μαρούλι και sauce tartare. Συνοδεύεται από πατάτα τηγανιτή",
          },
        ],
      },
      // { cat_id : 10,
      //   cat_description : ["Κομμάτια αφράτης ζύμης alla Siciliana"],
      //   items : [
      //     { id : 1, name : ["Marguerite"], price : 4.5, description : 'Mozzarella, pesto basil, tomato sauce, parmesan'},
      //     { id : 2, name : ["Magic Mushroom"], price : 4.5, description : 'Mushrooms mozzarella, parmesan, truffle oil, mushroom sauce'},
      //     { id : 3, name : ["Prosciutto"], price : 5, description : 'Mozzarella, prosciutto, tomato sauce, black pepper'}
      //   ]
      // },
      {
        cat_id: 10,
        // cat_description : ["Γεμιστές φωλιές από ζύμη πίτσας"],
        items: [
          {
            id: 1,
            name: ["Arancini"],
            price: 7.2,
            description:
              "Γεμισμένα με mozzarella .Συνοδεύεται από Napoli sauce με φρέσκο βασιλικό",
          },
          {
            id: 2,
            name: ["Fried Potato Carbonara"],
            price: 5.9,
            description: "Τηγανητές πατάτες με carbonara sauce",
          },
          {
            id: 3,
            name: ["Mexican Love fries"],
            price: 6.7,
            description:
              "Τηγανητές πατάτες με cheddar sauce, jalapeno pickles και crispy onions",
          },
          {
            id: 3,
            name: ["Cheese and Cuts Variety"],
            price: 15,
            description: "Ποικιλία τυριών και αλλαντικών",
          },
        ],
      },
      // { cat_id : 11,
      //   cat_description : ["Γεμιστές φωλιές από ζύμη πίτσας"],
      //   items : [
      //     { id : 1, name : ["The Boss"], price : 7, description : 'Χειροποίηρο μοσχαρίσιο burger, bacon, cheddar, ντομάτα, μαρούλι'},
      //     { id : 2, name : ["The Club"], price : 7, description : 'Η συνταγή που όλοι αγαπήσαμε τυλιγμένη μέσα σε ζύμη πίτσας'},
      //     { id : 3, name : ["Wizard"], price : 7.5, description : 'Ένας μαγικός συνδυασμός από pulled pork, με φρέσκια σαλάτα λαχανικών, vinaigrete soya και grill sauce'},
      //     { id : 4, name : ["Goddess"], price : 7, description : 'Το θεϊκό πάντρεμα μουστάρδας με μέλι σε ένα ζουμερό roast chicken, μαριναρισμένο με red chimichuri'}

      //   ]
      // },
      {
        cat_id: 11,
        // cat_description : ["Φρέσκα υλικά συνδυασμένα με γευστικές vinaigrette"],
        items: [
          {
            id: 1,
            name: ["Caesars"],
            price: 8.8,
            description:
              "Πράσινη σαλάτα με κοτόπουλο, bacon, sauce, πούδρα παρμεζάνας, ψητό καλαμπόκι και croutons",
          },
          // { id : 1, name : ["Chicken Salad"], price : 8, description : 'Πράσινη σαλάτα με ψητό κοτόπουλο, βραστό αυγό, πούδρα παρμεζάνας vinaigrette λεμονιού και crumble δημητριακών'},
          // { id : 1, name : ["La Scala"], price : 7.5, description : 'Μια συνταγή από το διάσημο Ιταλικό εστιατόριο Beverly Hills, πράσινο μαρούλι, iceberg, salami Milano, mozzarella, parmesan, μαριναρισμένα ρεβύθια'},
          // { id : 1, name : ["Panzanella"], price : 8, description : 'Ζουμερά ντοματίνια και ντομάτες, ψητές πολύχρωμα πιπεριές, ελιές, φρέσκο βασιλικό, Ricotta και τραγανό σκορδόψωμο'},
          // { id : 1, name : ["Greca Fysilli"], price : 7, description : 'Φρέσκα ζυμρικά με δροσερά ντοματίνια, φέτα, πιπεριά, αγγούρι, κάπαρη, pesto μυρωδικών, σουσάμι και vinaigrette μηλόξιδο'},
        ],
      },
      // { cat_id : 13,
      //   cat_description : ["Αφράτη ζύμη από την περιοχή της Σικελίας, έγινε διάσημη στις αρχές του 20ου αιώνα από μετανάστες στην Αμερική όπου μέχρι και σήμερα διατηρεί τη φήμη της"],
      //   items : [
      //     { id : 1, name : ["New York"], price : 12, description:"Από τις γειτονιές της μεγαλούπολης, σάλτσα ντομάτα, μανιτάρια, mozarella και χοιρομέρι"},
      //     { id : 2, name : ["Chicken Club"], price : 12, description:"Από την εξοχή της Σικελίας, καπνιστή μελιτζάνα, mozzarella, pecorino, βράστη πατάτα, μανιτάρια, σουσάμι, κρέμα τρούφας και φρέσκια ρόκα"},
      //     { id : 3, name : ["Alla Grece"], price : 12, description:"Από επιρροές του ελληνικού στοιχείου της περιοχής σάλτσα ντομάτα, πιπεριά, φέτα, ελιές, κάπαρη, κρεμμύδι"}
      //   ]
      // },
      {
        cat_id: 12,
        items: [
          {
            id: 1,
            name: ["Mushroom risotto"],
            price: 9.1,
            description:
              "Ριζότο μανιταριών με γλάσο από βαλσάμικο και λάδι λευκής τρούφας",
          },
          {
            id: 2,
            name: ["Stir fried rice & shrimps"],
            price: 9.2,
            description:
              "Τηγανητό ρύζι με λαχανικά και γαρίδες μαριναρισμένες σε τζίντζερ",
          },
        ],
      },
      // { cat_id : 14,
      //   cat_description : ["Για αυτούς που μία pizza δεν είναι ποτέ αρκετή δημιουργήσαμε μία διώροφη λιχουδιά"],
      //   items : [
      //     { id : 1, name : ["Deep In Cheese"], price : 15, description:"Βουτήξτε το λιωμένο τυρί γιατί όλοι ξέρουμε <cheese is never enough> mozzarella, parmesan, gouda, provolone, tomato sauce"},
      //     { id : 2, name : ["Salami"], price : 15, description:"Ξέροντας την αδυναμία που έχετε στο salami αέρος δε θα σας αφήσουμε με την λαχτάρα, mozzarella, salami, parmesan, gouda, provolone"}
      //   ]
      // },
      {
        cat_id: 13,
        // cat_description : ["Όπως όλα τα πράγματα εξελίσσονται, έτσι και η αγαπημένα μας Pizza, δημιουργώντας μια ζύμη φυσικής ωρίμανσης έχοντας σαν αποτέλεσμα να γίνει πιο εύπεπτη και εντυπωσιακή"],
        cat_description: ["Επιλογή από ζυμάρι Contemporanea ή Siciliana"],
        items: [
          // { id : 1, name : ["Margherita"], price : 8.5, description:"Ίσως η πιο διάσημη συνταγή η οποία έγινε για μια βασίλισσα, σάλτσα ντομάτα, mozzarella, parmesan, βασιλικός"},
          {
            id: 1,
            name: ["Margherita"],
            price: 7.8,
            extraPrice: { name: "Siciliana", price: 11.2 },
            description: "Σάλτσα ντομάτας, μοτσαρέλα, παρμεζάνα",
          },
          // { id : 2, name : ["Pepperoni"], price : 9, description:"Το πιο διαδομένο αλλαντικό, με την γνωστή πικάντικη γεύση, επάνω σε μία pizza, σάλτσα ντομάτα, pepperoni, mozzarella, chilli, τριμμένη φέτα"},
          {
            id: 2,
            name: ["Pepperoni"],
            price: 9,
            extraPrice: { name: "Siciliana", price: 13 },
            description:
              "Σάλτσα ντομάτας, pepperoni, μοτσαρέλα και τριμμένη φέτα",
          },
          {
            id: 3,
            name: ["Special Camino"],
            price: 10.5,
            extraPrice: { name: "Siciliana", price: 14.5 },
            description:
              "Σάλτσα ντομάτας, μοτσαρέλα provolone, bacon, μανιτάρια, πιπεριά και παρμεζάνα",
          },
          {
            id: 4,
            name: ["New York"],
            price: 9.7,
            extraPrice: { name: "Siciliana", price: 13.8 },
            description: "Σάλτσα ντομάτας, μανιτάρια, μοτσαρέλα, bacon",
          },
          {
            id: 5,
            name: ["Southern chicken"],
            price: 10.9,
            extraPrice: { name: "Siciliana", price: 14.6 },
            description:
              "Σάλτσα ντομάτας, μοτσαρέλα, κοτόπουλο ψητό και πιπεριά κόκκινη",
          },
          {
            id: 6,
            name: ["BBQ"],
            price: 10.9,
            extraPrice: { name: "Siciliana", price: 14.6 },
            description:
              "BBq sauce, provolone μοτσαρέλα, bacon, pulled pork, και πιπεριά πράσινη",
          },
          {
            id: 7,
            name: ["Alla Greca"],
            price: 10.3,
            extraPrice: { name: "Siciliana", price: 13.5 },
            description:
              "Σάλτσα ντομάτας, πιπεριά, φέτα, ελιές, κάπαρη, κρεμμύδι",
          },
          {
            id: 8,
            name: ["Prosciutto"],
            price: 10.9,
            extraPrice: { name: "Siciliana", price: 14.6 },
            description:
              "Σάλτσα ντομάτας, prosciutto, mozzarella και stracciatella",
          },

          // { id : 3, name : ["Mortadella"], price : 9.5, description:"Ποιος δεν αγάπησε αυτές τις μικρές λευκές κηλίδες και το σπασμένο φυστικί, σάλτσα ντομάτας, mortadella, mozzarella, pesto και stracciatella"},
          // { id : 4, name : ["Milano"], price : 9, description:"Από τον βορρά δν θα μπορούσε να απουσιάζει ένα γνώριμο Salami όπως αυτό του milano, σάλτσα ντομάτα, mozzarella, provolone, salami Milano, ρόκα, parmesan"},
        ],
      },
      {
        cat_id: 14,
        cat_description: [
          "Φρέσκα και χειροπoίητα ζυμαρικά από το εργαστήριό μας",
        ],
        items: [
          {
            id: 1,
            name: ["Tagliatelle Carbonara"],
            price: 8.2,
            description: "Parmesan cream και pancetta afumicatta",
          },
          {
            id: 2,
            name: ["Napoli"],
            price: 6,
            description: "Tagliatelle με σάλτσα ντομάτας",
          },
          {
            id: 3,
            name: ["Ravioli"],
            price: 8.7,
            description: "Γεμισμένα με Ricotta σε sauce από pesto genoveze",
          },
          // { id : 2, name : ['Rigatoni Caprese'], price : 9, description : 'Sauce ντομάτα και ντοματίνια, φρέσκο βασιλικό και buratta'},
          // { id : 3, name : ['Casarecce Alla Genova'], price : 5.5, description : 'Pesto βασιλικού εμπλουτισμένο με ξύσμα λεμόνι'},
          // { id : 4, name : ['Zitti Arabiata'], price : 6.5, description : 'Διάσημη πικάντικη συνταγή που αγκαλιάζει ένα ζυμαρικό με τρύπα στην μέση όπως του παστίτσιο'},
          {
            id: 4,
            name: ["Tagliatelle Con Pollo"],
            price: 8.8,
            description:
              "Φρέσκα ζυμαρικά με ψητό φιλέτο κοτόπουλο και σάλτσα από μανιτάρια",
          },
          {
            id: 5,
            name: ["Tortellini Bolognese"],
            price: 9.4,
            description:
              "Φρέσκο ζυμαρικό με σάλτσα bolognese και φρεσκοτριμμενη παρμεζάνα",
          },
          {
            id: 6,
            name: ["Fungi Casarecce"],
            price: 8.8,
            description:
              "Φρέσκο ζυμαρικό με ποικιλία μανιταριών σε σάλτσα Pecorino Romano",
          },
          {
            id: 7,
            name: ["Lasagna"],
            price: 9.5,
            description:
              "Γεμισμένα με bolognese γκραντιναρισμένα με μοτσαρέλα και παρμεζάνα",
          },
          {
            id: 8,
            name: ["Chicken Noodles"],
            price: 8.9,
            description:
              "Ζουμερά φιλετίνια κοτόπουλο, φρέσκα λαχανικά και κάσιους",
          },
          // { id : 6, name : ['Truffle Ravioli'], price : 11, description : "Ricotta, parmesan, truffle, truffle sauce, cereal crumble"}
        ],
      },
      {
        cat_id: 15,
        items: [
          // { id : 1, name : ["Tiramisu"], price : 5.5, description:"Savoyard βουτηγμένα σε σιρόπι Kalua και espresso αφράτη κρέμα mascarpone και κακάο"},
          { id: 1, name: ["Crème Brûlée"], price: 6.5 },
          { id: 2, name: ["Tiramisu"], price: 5.5 },
          // { id : 1, name : ["Pannacotta"], price : 5.5, description:"Αφράτη κρέμα βανίλιας και σάλτσα από βατόμουρα"},
          { id: 3, name: ["Pannacotta"], price: 5.5 },
        ],
      },
      {
        cat_id: 16,
        items: [
          {
            id: 1,
            name: ["Edamame"],
            price: 5.5,
            description:
              "Φασόλια σόγιας μαριναρισμένα με sweet chilli και σουσάμι kimchi",
          },
          {
            id: 2,
            name: ["Chicken Popcorn"],
            price: 5.8,
            description:
              "Μαριναρισμένες μπουκιές κοτόπουλο τηγανισμένες με tempura συνοδεύεται απο πικάντικη μαγιονέζα",
          },
          {
            id: 3,
            name: ["Shrimps tempura"],
            price: 9.5,
            description:
              "συνοδεύονται απο σάλτσα wakame και μαγιονέζα με teriyaki mayo sauce",
          },
          {
            id: 4,
            name: ["Spring Rolls"],
            price: 6.5,
            description:
              "Τραγανά ρολάκια γεμισμένα με λαχανικά σε φύλλο ρυζιού συνοδεύεται απο sweet and sour sauce",
          },
          {
            id: 5,
            name: ["Dumplings"],
            price: 8.0,
            description: "Με κοτόπουλο και λαχανικά σε ponzu sauce",
          },
        ],
      },
      {
        cat_id: 17,
        items: [
          {
            id: 6,
            name: ["Salmon"],
            price: 8.0,
            description:
              "Ρύζι ατμού με λαχανικά, αβοκάντο edamame και μαριναρισμένο σολομό",
          },
          {
            id: 7,
            name: ["Vegetables"],
            price: 7.0,
            description:
              "Ρύζι ατμού με λαχανικά edamame, φύτρες φασόλι, bamboo, αυγό τηγανητό",
          },
          {
            id: 8,
            name: ["Chicken"],
            price: 8.5,
            description:
              "Τηγανητό ρύζι σε σισαμέλαιο με σπασμένη ομελέτα, λαχανικά, edamame, ψητό γλασαρισμένο κοτόπουλο με satay sauce",
          },
          {
            id: 9,
            name: ["Duck"],
            price: 12.0,
            description:
              "Τηγανητό ρύζι σε σισαμέλαιο με σπασμένη ομελέτα λαχανικά πάπια γλασαρισμένη με tonkatsu sauce",
          },
        ],
      },
      {
        cat_id: 18,
        items: [
          {
            id: 1,
            name: ["Shrimps"],
            price: 9.5,
            description:
              "Egg noodles με stir fry λαχανικά σε σισαμέλαιο, αρωματισμένα με τζίντζερ, lemon grass κόλιανδρο και lime",
          },
          {
            id: 2,
            name: ["Chicken"],
            price: 9.5,
            description:
              "Udon noodles με stir fry λαχανικά, peanut butter sauce, σουσάμι και κάσιους",
          },
          {
            id: 3,
            name: ["Duck"],
            price: 12.0,
            description:
              "Udon noodles με πιπεριές και κινέζικο λάχανο σε hoisin sauce και στημένο lime",
          },
        ],
      },
      {
        cat_id: 19,
        items: [
          {
            id: 1,
            name: ["California"],
            price: 9.0,
            description:
              "Ρολλάκι ρυζιού τυλιγμένο με φύκι nori γεμισμένο με λαχανικά και αβοκάντο topping philadelphia mayo teriyaki glaze και crispy onion",
          },
          {
            id: 2,
            name: ["Veggie"],
            price: 7.5,
            description:
              "Ρολλάκι ρυζιού τυλιγμένο σε φύκι Nοri, γεμισμένο με λαχανικά και αβοκάντο topping vegan mayo green tobiko σχοινόπρασο",
          },
          {
            id: 3,
            name: ["Vegetarian"],
            price: 9.5,
            description:
              "Inside out ρολλάκι ρυζιού πασπαλισμένο με μαύρο σουσάμι, γεμισμένο με λαχανικά και tofu με επικάλυψη μαριναρισμένο αγγούρι vegan mayo και crispy onion",
          },
          {
            id: 4,
            name: ["Popcorn shrimp"],
            price: 11.0,
            description:
              "Inside out ρολλάκι ρυζιού πασπαλισμένο με πορτοκάλι tobiko, γεμισμένο με λαχανικά μάνγκο topping γαρίδα popcorn sweet chilly mayo masago arare",
          },
          {
            id: 5,
            name: ["Tuna"],
            price: 10.0,
            description:
              "Ρολλάκι ρυζιού τυλιγμένο σε φύκι Nori γεμισμένο με τόνο λαχανικά και iceberg topping kewpie mayo,black tobiko και fried panko",
          },
          {
            id: 6,
            name: ["Shrimp"],
            price: 11.0,
            description:
              "Ρολλάκια ρυζιού τυλιγμένα με φύκι Nori γεμισμένα με γαρίδες, λαχανικά μαγιονέζα αβοκάντο topping tobiko hoisin, fried panko και wakame",
          },
          {
            id: 7,
            name: ["Dragon"],
            price: 12.0,
            description:
              "Upside down rolls γεμισμένα με καβούρι και αβοκάντο γλυκόξινη sauce, κόκκινο tobiko και μαγιονέζα αβοκάντο",
          },
          {
            id: 8,
            name: ["Crusty"],
            price: 12.5,
            description:
              "Ρολλάκια ρυζιού τυλιγμένα ανάποδα και πασπαλισμένα με σουσάμι soya, γεμισμένα με σολομό, λαχανικά κρέμα τυριού, topping μαγιονέζα με μάνγκο relish αγγούρι και ραπανάκια",
          },
          {
            id: 9,
            name: ["Smoked salmon"],
            price: 13.0,
            description:
              "Γεμισμένα με καπνιστό σολομό φιλαδέλφεια, αγγούρι, αβοκάντο και ice berg",
          },
          {
            id: 10,
            name: ["Crunchy"],
            price: 12.0,
            description:
              "Ρολλάκια ρυζιού τυλιγμένα με φύλλο Nori γεμισμένα με γαρίδα και λαχανικά τηγανισμένα σε tempura topping μαγιονέζα σχοινόπρασο και tonkatsu sauce",
          },
          {
            id: 11,
            name: ["Burrito"],
            price: 14.0,
            description:
              "Double filed sushi roll με λαχανικά και τόνο teriyaki sauce spicy mayo και wakame",
          },
        ],
      },
      {
        cat_id: 7,
        sub_category: ["RUMS"],
        items: [
          { id: 1, name: ["Havana Club Añejo 3yo Años"], price: 8 },
          { id: 2, name: ["Havana Club Añejo Especial"], price: 9 },
          { id: 3, name: ["Havana Club Añejo 7yo Años"], price: 10 },
          { id: 4, name: ["Diplomatico Anejo"], price: 10 },
          { id: 5, name: ["Diplomatico Mantuano"], price: 10 },
        ],
      },

      {
        cat_id: 7,
        sub_category: ["VODKA"],
        items: [
          { id: 1, name: ["Absolut vodka"], price: 8 },
          { id: 2, name: ["Grey Goose"], price: 12 },
          { id: 3, name: ["Belvedere"], price: 12 },
          { id: 4, name: ["Russian Standard"], price: 8 },
          { id: 5, name: ["Russian Standard Platinum"], price: 10 },
        ],
      },
      {
        cat_id: 7,
        sub_category: ["TEQUILA"],
        items: [
          { id: 1, name: ["Olmeca Tequila Silver"], price: 8 },
          { id: 2, name: ["Olmeca Tequila Reposado"], price: 8 },
          { id: 3, name: ["El Jimador Blanco"], price: 8 },
          { id: 4, name: ["El Jimador Reposado"], price: 8 },
          { id: 5, name: ["Don Julio Blanco"], price: 12 },
          { id: 6, name: ["Don Julio Reposado"], price: 12 },
          { id: 7, name: ["Patron Reposado"], price: 12 },
          { id: 8, name: ["Patron Silver"], price: 12 },
        ],
      },
      {
        cat_id: 7,
        sub_category: ["GIN"],
        items: [
          { id: 1, name: ["Beefeater London Dry Gin"], price: 8 },
          { id: 2, name: ["Beefeater 24"], price: 12 },
          { id: 3, name: ["Beefeater 0%"], price: 8 },
          { id: 4, name: ["Malfy Gin"], price: 10 },
          { id: 5, name: ["Hendricks"], price: 12 },
          { id: 6, name: ["Bombay"], price: 8 },
          { id: 7, name: ["Bulldog London Dry Gin"], price: 8 },
          { id: 8, name: ["Langley's"], price: 8 },
          { id: 9, name: ["Gin Mare"], price: 10 },
        ],
      },
      {
        cat_id: 7,
        sub_category: ["WHISKEY"],
        items: [
          { id: 1, name: ["Jameson"], price: 8 },
          { id: 2, name: ["Jameson Black Barrel"], price: 10 },
          { id: 3, name: ["Chivas Regal 12yo"], price: 9 },
          { id: 4, name: ["Chivas Regal 18yo"], price: 18 },
          { id: 5, name: ["Ballantine's Finest"], price: 8 },
          { id: 6, name: ["Four Roses Bourbon"], price: 8 },
          { id: 7, name: ["Jack Daniel's"], price: 9 },
          { id: 8, name: ["Gentleman Jack"], price: 12 },
          { id: 9, name: ["Johnie Walker Black Label"], price: 10 },
          { id: 10, name: ["Johnie Walker Blue Label"], price: 45 },
          { id: 11, name: ["Dimple"], price: 9 },
          { id: 12, name: ["Cardu"], price: 9 },
          { id: 13, name: ["Oban"], price: 10 },
          { id: 14, name: ["Glenfiddich"], price: 10 },
          { id: 15, name: ["Lagavulin “10”"], price: 10 },
        ],
      },
    ],
    takeAway: false,
    filter: "",
  };

  componentDidMount() {
    let counter = 0;
    this.state.products.forEach((product) => {
      product.items.forEach((item) => counter++);
    });
    //console.log("Total : "+counter);

    setTimeout(function () {
      const intro = document.querySelector(".intro");
      intro.classList.add("ready");
      // setTimeout(function(){
      //   const intro = document.querySelector('.intro-info p.est');
      //   intro.classList.add('show');
      // }, 1200);
      // const spans = document.querySelectorAll('.intro-info p.moto span');
      // for(let i = 0; i < spans.length; i++){
      //   setTimeout(function(){
      //     spans[i].classList.add('show');
      //   }, 2000 + 400*i);
      // }

      setTimeout(function () {
        const enter = document.querySelector(".enter");
        enter.classList.remove("hide");
        setTimeout(function () {
          enter.classList.add("show");
        }, 500);
      }, 1200);
    }, 700);
  }

  getTitle = (id) => {
    /*
    if(this.state.categories[id].superCat){
      const index = this.state.categories[id].superID;
      return this.state.superCategories[index].name[0];
    }else{
      return this.state.categories[id].name[0];
    }
    */
    return this.state.categories[id].name[0];
  };

  getCategory = (id) => {
    return this.state.categories[id];
  };

  hasTakeAway = (id) => {
    return this.state.categories[id].takeAway;
  };

  getProducts = (id) => {
    //console.log("get products" + index);
    //console.log(id);
    //let hasSuper = this.state.categories[id].superCat;
    //console.log(hasSuper);
    let products = [];
    this.state.products.forEach((category, index) => {
      if (category.cat_id === id) {
        let itemToPush = { ...category, id: index };
        products.push(itemToPush);
      }
    });
    return products;
  };

  setPrice = (flag) => {
    this.setState({ takeAway: flag });
  };

  togglePrice = () => {
    let value = this.state.takeAway;
    this.setState({ takeAway: !value });
  };

  setNavigation = (id) => {
    let navigation = [];
    const superIndex = this.state.categories[id].superID;
    if (this.state.superCategories[superIndex].hasOwnProperty("navigation")) {
      navigation = [...this.state.superCategories[superIndex].navigation];
    }
    return navigation;
  };

  setFilter = (filter) => {
    if (this.state.filter === filter) {
      this.resetFilter();
    } else {
      this.setState({ filter: filter });
    }
  };

  resetFilter = () => {
    this.setState({ filter: "" });
  };

  hideIntro = () => {
    const intro = document.querySelector(".intro");
    intro.classList.add("hide");
  };

  render() {
    return (
      <HashRouter basename="/">
        <div className="App">
          <div className="wrapper">
            <div className="intro">
              <div className="intro-wrapper">
                <div className="intro-logo">
                  <div className="intro-image">
                    <img
                      src="assets/logos/baccara_logo.png"
                      alt="baccara logo"
                    />
                  </div>
                  {/* <div className="intro-info">
                          <p className="est">EST 2006</p>
                          <p className="moto">
                            <span>WHERE</span>
                            <span>EVERYTHING</span>
                            <span>BEGINS</span>
                          </p>
                        </div> */}
                </div>
                <div className="enter hide">
                  <Link to="/Menu">
                    <button onClick={this.hideIntro}>Τιμοκατάλογος</button>
                  </Link>
                  <aside>
                    Delivery & Take Away -{" "}
                    <a href="tel:+302463020001">2463020001</a>
                  </aside>
                </div>
              </div>
            </div>
            <header>
              <div className="headerWrapper">
                <div className="logo">
                  <img
                    src="assets/logos/baccara_logo_sm.png"
                    alt="baccara logo"
                  />
                </div>
              </div>
              {
                //<p><span>EST 2006</span>WHERE EVERYTHING BEGINS</p>
              }
            </header>
            <Routes>
              <Route
                path="menu"
                element={
                  <MainMenu
                    resetFilter={this.resetFilter}
                    initPrice={(value) => this.setPrice(false)}
                    categories={this.state.categories}
                    superCategories={this.state.superCategories}
                  />
                }
              />
              <Route path="category">
                <Route
                  path=":id"
                  element={
                    <Category
                      takeAwayOption={(id) => this.hasTakeAway(id)}
                      category={(id) => this.getCategory(id)}
                      navigation={(id) => this.setNavigation(id)}
                      takeAway={this.state.takeAway}
                      filter={this.state.filter}
                      setFilter={(filter) => this.setFilter(filter)}
                      resetFilter={this.resetFilter}
                      setPrice={(value) => this.setPrice(value)}
                      products={(id) => this.getProducts(id)}
                      title={(id) => this.getTitle(id)}
                    />
                  }
                />
              </Route>
            </Routes>
          </div>
          <footer>
            <Footer />
          </footer>
        </div>
      </HashRouter>
    );
  }
}

export default App;
